import { Outlet } from 'react-router-dom';
import { Link } from 'react-router-dom';
import LogoIcon from "assets/icons/logo_icon.png";
import LogoPlusIcon from "assets/icons/logo_plus_icon.svg";

const IndexLayout = () => {
	
	const appName = process.env.REACT_APP_NAME;
	return (
		<div>
		<div className="layout-header">
    <div className="layout-toggle-menu" 
	style={{ 
			display: 'flex', 
			justifyContent: 'center', 
			alignItems: 'center', 
			marginBottom: '-60px', 
			marginTop:'30px'
			}}>
    {/* <div style={{ 
				cursor: "pointer",
			 	}}>
            <img src={LogoPlusIcon} alt="Logo Plus" />
        </div> */}
        <Link to="/" className="layout-topbar-logo flex-grow-none">
            <img src={LogoIcon} alt={appName} style={{height:"45px"}}/>
        </Link>
    </div>
</div>
<div className="layout-main-container" style={{ marginTop: '-10px' }}>
    <div className="layout-main">
        <Outlet />
    </div>
</div>
</div>
	
	);
}
export default IndexLayout;
